import { defaultStore } from '../library/firebase'
/**
 * @description 이 함수는 실행 날짜 기준으로 그 이상의 날짜면 남기는 필터이다.
 * 과거 지정 휴일은 필요하지 않기 때문이다.
 * @param holidays 재정의할 쉬는 날짜
 */
const deletePassedDate = holidays =>
  holidays.filter(v => {
    return new Date() <= new Date(v)
  })

export const setHoliday = (days, uid) => {
  const convertDays = deletePassedDate(days)
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .get()
      .then(doc => {
        let data = {}
        if (doc.exists) {
          data = Object.assign(doc.data(), { holidays: convertDays })
        } else {
          data = { holidays: convertDays }
        }
        setTimeout(() => {
          defaultStore
            .collection('users_availability')
            .doc(uid)
            .set(data)
            .then(() => {
              // 서비스 업데이트 하기
              defaultStore
                .collection('photographers_service')
                .where('uid', '==', uid)
                .get()
                .then(snap => {
                  if (snap.size > 0) {
                    snap.forEach(doc => {
                      // const serviceData = doc
                      defaultStore
                        .collection('photographers_service')
                        .doc(doc.id)
                        .update(data)
                        .then(() => {
                          console.log('완료')
                        })
                    })
                  }
                  resolve(true)
                })
            })
            .catch(error => {
              console.log('Error getting document:', error)
              reject(error)
            })
        }, 0)
      })
  })
}

export const setTime = (obj, uid) => {
  console.log('api:', obj)
  return new Promise((resolve, reject) => {
    const saveData = {}
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .get()
      .then(doc => {
        let data = {}
        if (doc.exists) {
          data = Object.assign(doc.data(), obj)
          if (typeof data.holidays !== 'undefined') {
            data.holidays = deletePassedDate(data.holidays)
          }
        }
        Object.assign(saveData, data)
      })
      .then(() => {
        defaultStore
          .collection('users_availability')
          .doc(uid)
          .set(saveData)
          .then(doc => {
            console.log('Set successfully', doc)
            //  TODO 여기에서 저장이 되면, photographer_service에더 저장이 되어야 한다.
            defaultStore
              .collection('photographers_service')
              .where('uid', '==', uid)
              .get()
              .then(snap => {
                if (snap.size > 0) {
                  snap.forEach(doc => {
                    // const serviceData = doc
                    defaultStore
                      .collection('photographers_service')
                      .doc(doc.id)
                      .update({ times: saveData.times })
                      .then(() => {
                        console.log('완료')
                      })
                  })
                }
                resolve(true)
              })
            resolve(true)
          })
          .catch(error => {
            console.log('Error getting document:', error)
            reject(error)
          })
      })
  })
}

/**
 * Availability 의 타임바의 상태값을 저장한다.
 * @param {*} timeBar availability의 타임 바
 * @param {*} uid 유저의 아이디 값
 */
export const updateTimeBar = (timeBar, uid) => {
  console.log(timeBar, uid)
  return new Promise(resolve => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .collection('timeBar')
      .update(timeBar)
      .then(() => {
        console.log('Document successfully updated!')
        resolve(true)
      })
      .catch(error => {
        console.error('Error updating document: ', error)
      })
  })
}

export const setTimeBar = (timeBar, uid) => {
  return new Promise(resolve => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .set({ timeBar: timeBar })
      .then(() => {
        console.log('Document successfully updated!')
        resolve(true)
      })
      .catch(error => {
        console.error('Error timeBar document: ', error)
      })
  })
}

// 사실 필요는 없다. availability의 get에서 모두 가져오기 떄문이다.
export const getTimeBar = (timeBar, uid) => {
  return new Promise(resolve => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .then(doc => {
        console.log('Document successfully updated!')
        if (doc.exists) {
          resolve(doc.data())
        } else {
          resolve([])
        }
      })
      .catch(error => {
        console.error('Error timeBar document: ', error)
      })
  })
}

export const getHoliday = uid => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(doc.data().holidays)
        } else {
          resolve(false)
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getTimes = uid => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(doc.data())
        } else {
          resolve({})
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getTime = uid => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('users_availability')
      .doc(uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          resolve(doc.data().times)
        } else {
          resolve({})
        }
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

/*
const updatePhotographerService = (days, uid) => {
  new Promise((resolve, reject) => {
    defaultStore
      .collection('photographers_service')
      .where('uid', '==', uid)
      .get()
      .then(snap => {
        let count = 0
        snap.forEach(doc => {
          if (doc.exists) {
            let serviceDetail = doc.data()
            serviceDetail.holidays = days
            defaultStore
              .collection('photographers_service')
              .doc(doc.id)
              .update(serviceDetail)
              .then(() => {
                count++
                if (days.length === count) {
                  resolve(true)
                }
              })
          } else {
            console.log('서비스가 존재 하지 않습니다.')
          }
        })
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
*/
